module.exports = __webpack_public_path__ + "img/donwload2.1a1b67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community/donwload2.png
// module id = M/6Z
// module chunks = 16